import React from 'react'
import { LibraryAgentLanguage } from './library-agent-language'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { LibraryVersion } from '../../helpers/ui-interfaces'
import { LibraryCommonUIProps } from '../../helpers/libraries-interfaces'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'

export interface LibraryVersionUIProps {
  version?: LibraryVersion | null
  language?: LibraryCommonUIProps['language']
  className?: string
}

const libraryReleaseVersionCss = css`
  margin-right: 3px;
  font-size: 14px;
  color: ${theme.color.neutral100};
`
export const LibraryFormattedVersion = ({
  version = '?',
  language,
  className
}: LibraryVersionUIProps) => {
  let displayVersion: string | string[] = version || '?'

  if (
    typeof language === 'string' &&
    language?.toLowerCase() === LibraryAgentLanguage.GO.getValue().toLowerCase()
  ) {
    const splitVersion = displayVersion.split('-')

    if (splitVersion.length === 1) {
      displayVersion = splitVersion
    }

    if (splitVersion.length === 3) {
      return (
        <Tooltip placement="top" body={<span>{displayVersion}</span>}>
          <span className={className ? className : libraryReleaseVersionCss}>
            {splitVersion[0]}
            &nbsp;-
            <span style={{ fontSize: '12px' }}>
              &nbsp;
              {splitVersion[2]}
            </span>
          </span>
        </Tooltip>
      )
    }
  } else {
    if (
      displayVersion &&
      displayVersion !== '?' &&
      !displayVersion.startsWith('v')
    ) {
      displayVersion = 'v'.concat(displayVersion)
    }
  }

  return (
    <span className={libraryReleaseVersionCss}>
      {!!displayVersion ? displayVersion : '?'}
    </span>
  )
}
